<template>
  <v-row
    no-gutters
    align="center"
    justify="center"
    class="deltia-card ml-2 mr-2 mb-4 pa-5"
  >
    <!-- Columna para el nombre de la sucursal -->
    <v-col cols="12" md="3">
      <p class="content--text font-weight-medium mb-0">
        {{ name }}
      </p>
    </v-col>
    <!-- Columna para la dirección -->
    <v-col cols="12" md="6">
      <p class="content--text font-weight-medium mb-0">
        {{ address }}
      </p>
    </v-col>
    <!-- Columna para la fecha -->
    <v-col cols="12" md="2">
      <p class="content--text font-weight-medium mb-0">
        {{ formatDate(date) }}
      </p>
    </v-col>
    <!-- Columna para los ajustes (en pantallas grandes)-->
    <v-col
      class="hidden-sm-and-down"
      cols="12"
      md="1"
      align="right"
      justify="center"
    >
      <!-- Ajustes para actualizar o eliminar -->
      <v-menu top v-model="menu" v-if="shouldShowSettings">
        <template v-slot:activator="{ on: menu }">
          <v-btn icon dark v-on="menu" color="primary">
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>
        </template>
        <!-- Menú para actualizar una sucursal -->
        <v-list>
          <!-- Modal para actualizar una sucursal -->
          <UpdateBranch
            :branchId="branchId"
            @branch-error="onBranchError"
            @branch-updated="onBranchUpdated"
          ></UpdateBranch>
          <DeleteBranch
            :branchId="branchId"
            @branch-error="onBranchError"
            @branch-deleted="onBranchDeleted"
          ></DeleteBranch>
        </v-list>
      </v-menu>
    </v-col>
    <!-- Columna para los ajustes (en pantallas pequeñas)-->
    <v-col
      class="hidden-md-and-up"
      cols="12"
      md="1"
      align="center"
      justify="center"
    >
      <!-- Ajustes para actualizar o eliminar -->
      <v-menu top v-model="secondMenu" v-if="shouldShowSettings">
        <template v-slot:activator="{ on: secondMenu }">
          <v-btn
            color="primary"
            class="font-weight-bold"
            text
            v-on="secondMenu"
          >
            Actualizar
          </v-btn>
        </template>
        <!-- Menú para actualizar una sucursal -->
        <v-list>
          <!-- Modal para actualizar una sucursal -->
          <UpdateBranch
            :branchId="branchId"
            @branch-error="onBranchError"
            @branch-updated="onBranchUpdated"
          ></UpdateBranch>
          <DeleteBranch
            :branchId="branchId"
            @branch-error="onBranchError"
            @branch-deleted="onBranchDeleted"
          ></DeleteBranch>
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
// Importar componentes
import UpdateBranch from "@/components/branches/modals/UpdateBranch";
import DeleteBranch from "@/components/branches/modals/DeleteBranch";

// Importar mixins
import dateFormat from "@/mixins/dateFormat.js";

export default {
  name: "BranchItem",
  mixins: [dateFormat],
  data() {
    return {
      dialog: false,
      menu: false,
      secondMenu: false
    };
  },
  components: {
    UpdateBranch,
    DeleteBranch
  },
  props: {
    date: {
      type: String
    },
    name: {
      type: String
    },
    address: {
      type: String
    },
    branchId: {
      type: String
    },
    shouldShowSettings: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onBranchUpdated() {
      this.$emit("branch-updated");
    },
    onBranchDeleted() {
      this.$emit("branch-deleted");
    },
    onBranchError(errorMessage) {
      this.$emit("branch-error", errorMessage);
    }
  }
};
</script>
